import axios from 'axios';
import { JetServiceSlipBody } from '~/server/payments/types/BoletoTypes';

export const getSlipPdfCommand = {
  execute: async (slipBody: JetServiceSlipBody): Promise<any> => {
    const response = await axios.post('https://cloud.jetsoft.com.br/JETServicos/apiservicos/apijetservico/WSGerarReciboPDF', slipBody);
    return response.data;
  },
};
